import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  activeNotCompletedUploadsSelector,
  notStartedUploadsIdsSelector,
  removeUploadsAction,
  resetNonCompletedUploadsAction,
  useUploaderStore,
} from '@air/redux-uploader';

import { type UseDeleteUploadParams, useDeleteUpload } from '..';

export const useDeleteNonCompletedUploads = ({ onDelete }: UseDeleteUploadParams | undefined = {}) => {
  const dispatch = useDispatch();
  const store = useUploaderStore();
  const { deleteUpload } = useDeleteUpload({ onDelete });

  const deleteAllNonCompletedUploads = useCallback(async () => {
    const notStartedUploadsIds = notStartedUploadsIdsSelector(store.getState());
    const startedUploads = activeNotCompletedUploadsSelector(store.getState());

    dispatch(removeUploadsAction({ uploadIds: notStartedUploadsIds }));
    startedUploads.forEach((upload) => {
      deleteUpload(upload);
    });

    dispatch(resetNonCompletedUploadsAction());
  }, [deleteUpload, dispatch, store]);

  return {
    deleteAllNonCompletedUploads,
  };
};
